import { createFileRoute, redirect } from "@tanstack/react-router";

import { hasCoachAccountSettings } from "./-coach-account-settings";

export const Route = createFileRoute("/_user/settings/")({
  staticData: { title: "Settings" },
  beforeLoad: async ({ context }) => {
    throw redirect({
      to: (await hasCoachAccountSettings(
        context.queryClient,
        context.user.clerkUserId,
      ))
        ? "/settings/account"
        : "/settings/profile",
    });
  },
});
